
import React from 'react';
import { ConfirmingReportItemPreviewModalTemplate } from 'themes/application/confirming-report/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { ConfirmingReportItemPreviewModalViewStore } from 'application/confirming-report/stores';

@setCurrentView((rootStore, componentProps) => new ConfirmingReportItemPreviewModalViewStore(rootStore, componentProps), 'confirmingReportItemPreviewModalViewStore')
@observer
class ConfirmingReportItemPreviewModal extends React.Component {
    render() {
        return <ConfirmingReportItemPreviewModalTemplate {...this.props} />
    }
}

export default ConfirmingReportItemPreviewModal;
